/* SOLBELI — Búsqueda de cabecera: historial local y capa de enfoque.
   Código propio, sin dependencias de Shrine ni de librerías. Idempotente y con desmontaje. */
(() => {
  if (window.__solbeliSearchUI) return;
  window.__solbeliSearchUI = true;

  const KEY = 'solbeli_search_history';
  const LEGACY_KEYS = [];            // claves antiguas a migrar una sola vez (completar si se conocen)
  const MIGRATED = KEY + ':migrated';
  const MAX = 10;
  const ACTIVE = 'solbeli-dawn-search-active';
  const OVERLAY_MQ = '(min-width: 600px)';

  const norm = items => {
    const seen = new Set(), out = [];
    for (const x of Array.isArray(items) ? items : []) {
      if (typeof x !== 'string') continue;
      const t = x.trim(), k = t.toLocaleLowerCase();
      if (!t || seen.has(k)) continue;
      seen.add(k); out.push(t);
      if (out.length === MAX) break;
    }
    return out;
  };
  const read = () => { try { return norm(JSON.parse(localStorage.getItem(KEY) || '[]')); } catch { return []; } };
  const save = items => { try { localStorage.setItem(KEY, JSON.stringify(norm(items))); } catch {} };
  const migrate = () => {
    try {
      if (!LEGACY_KEYS.length || localStorage.getItem(MIGRATED)) return;
      let merged = read();
      for (const k of LEGACY_KEYS) {
        let v = []; try { v = JSON.parse(localStorage.getItem(k) || '[]'); } catch {}
        merged = merged.concat(Array.isArray(v) ? v : []);
      }
      save(merged); localStorage.setItem(MIGRATED, '1');
    } catch {}
  };

  const roots = new Map();           // root -> AbortController
  let backdrop = null;

  function ensureBackdrop() {
    if (backdrop && backdrop.isConnected) return backdrop;
    backdrop = document.createElement('div');
    backdrop.className = 'solbeli-dawn-search-backdrop';
    backdrop.setAttribute('aria-hidden', 'true');
    // mousedown no debe mover el foco: así el clic completo llega a la capa y no al contenido de debajo.
    backdrop.addEventListener('mousedown', e => e.preventDefault());
    backdrop.addEventListener('click', e => {
      e.preventDefault(); e.stopPropagation();
      roots.forEach((_, root) => root.dispatchEvent(new CustomEvent('solbeli:close')));
    });
    document.body.append(backdrop);
    return backdrop;
  }

  function init(root) {
    if (roots.has(root)) return;
    const input = root.querySelector('input[type="search"]'),
          panel = root.querySelector('[data-solbeli-search-history]'),
          list = root.querySelector('[data-solbeli-history-items]'),
          form = input && input.form;
    if (!input || !panel || !list || !form) return;
    const ac = new AbortController(), opt = { signal: ac.signal };
    roots.set(root, ac);
    const mq = window.matchMedia(OVERLAY_MQ);

    const closeHistory = () => { panel.hidden = true; };
    const setOverlay = on => {
      document.body.classList.toggle(ACTIVE, !!on);
      if (on) ensureBackdrop();
    };
    const syncOverlay = () => setOverlay(mq.matches && root.contains(document.activeElement));
    const closeAll = () => { closeHistory(); setOverlay(false); if (root.contains(document.activeElement)) document.activeElement.blur(); };

    const hrefFor = term => {
      const u = new URL(form.getAttribute('action') || '/search', location.origin);
      u.searchParams.set('q', term);
      const p = form.querySelector('[name="options[prefix]"]');
      if (p) u.searchParams.set(p.name, p.value);
      return u.pathname + u.search;
    };
    const submitTerm = term => {
      input.value = term;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    };

    function render() {
      const terms = read();
      list.replaceChildren();
      if (input.value.trim() || !terms.length) { closeHistory(); return; }
      terms.forEach(term => {
        const li = document.createElement('li'), a = document.createElement('a'), del = document.createElement('button');
        a.textContent = term; a.href = hrefFor(term);
        a.addEventListener('click', e => { e.preventDefault(); submitTerm(term); });
        del.type = 'button'; del.textContent = '×';
        del.setAttribute('aria-label', 'Eliminar búsqueda: ' + term);
        del.addEventListener('click', () => {
          save(read().filter(x => x.toLocaleLowerCase() !== term.toLocaleLowerCase()));
          render();
          input.focus({ preventScroll: true });   // foco estable tras borrar
        });
        li.append(a, del); list.append(li);
      });
      panel.hidden = false;
    }

    form.addEventListener('submit', () => {
      const value = input.value.trim();
      if (value) save([value, ...read()]);
      closeHistory(); setOverlay(false);
    }, opt);
    input.addEventListener('focus', () => { render(); syncOverlay(); }, opt);
    input.addEventListener('input', () => { if (input.value.trim()) closeHistory(); else render(); }, opt);
    // Salir del conjunto (Tab, clic fuera): se cierra todo. Se reevalúa tras el cambio de foco.
    root.addEventListener('focusout', () => requestAnimationFrame(() => {
      if (!root.contains(document.activeElement)) { closeHistory(); syncOverlay(); }
    }), opt);
    root.addEventListener('keydown', e => { if (e.key === 'Escape') { closeAll(); input.blur(); } }, opt);
    root.addEventListener('solbeli:close', closeAll, opt);
    mq.addEventListener && mq.addEventListener('change', syncOverlay, opt);
    // Volver con el botón Atrás (bfcache): sin capa residual.
    window.addEventListener('pageshow', () => { closeHistory(); setOverlay(false); }, opt);
  }

  function destroy(root) {
    const ac = roots.get(root);
    if (ac) ac.abort();
    roots.delete(root);
    if (!roots.size) { document.body.classList.remove(ACTIVE); backdrop && backdrop.remove(); backdrop = null; }
  }

  function boot() {
    migrate();
    roots.forEach((_, r) => { if (!r.isConnected) destroy(r); });
    document.querySelectorAll('.solbeli-dawn-inline-search').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll && e.target.querySelectorAll('.solbeli-dawn-inline-search').forEach(destroy);
    boot();
  });
})();
